import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { LigneFinancementProduit } from '../../model/ligneFinancement/ligneFinancementProduit';

@Injectable({
  providedIn: "root"
})
export class LigneFinancementProduitService {
  constructor(private _restClientService: RestClientService) {}

  getAllLigneFinancementProduit() {
    return this._restClientService.load<LigneFinancementProduit[]>(
      "ligne-financement-produit/find-all"
    );
  }

  getById(id) {
    return this._restClientService.load<LigneFinancementProduit>(
      "ligne-financement-produit/find-by-id//" + id
    );
  }

  add(ligneFinancement) {
    return this._restClientService.save<LigneFinancementProduit>(
      "ligne-financement-produit/add",
      ligneFinancement
    );
  }

  update(ligneFinancement) {
    return this._restClientService.put<LigneFinancementProduit>(
      `ligne-financement-produit/update`,
      ligneFinancement
    );
  }

  delete(id) {
    return this._restClientService.delete<any>(
      "ligne-financement-produit/delete/" + id
    );
  }
}
